(function OffersPotential($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Offers/potential', function onload() {
			$('.num-result-filter').change(function filterClicked() {
				var offer_id    = $(this).data('id'),
					num_results = $(this).val();

				document.location =  Adzuki.base_uri + '/Offers/potential/' + offer_id + '/' + num_results;
			});
		});
	});
}(jQuery, window.Adzuki || {}));
